// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
// biome-ignore lint/style/useImportType: <explanation>
import * as React from 'react';
import { PageLoading } from '../loading';
import RightPager from './RightPager';

interface Props {
  readonly content: React.ReactElement;
  readonly isInitialLoad: boolean;
  readonly isLoadingMore: boolean;
  readonly page: number;
  readonly pageSize: number;
  readonly currentPageSize: number | null | undefined;
  readonly hasPreviousPage: boolean;
  readonly hasNextPage: boolean;
  readonly onUpdatePage: (page: number) => void;
  readonly onUpdatePageSize?: (pageSize: number) => void;
  readonly error?: string | null | undefined;
  readonly omitPager?: boolean;
  readonly disablePadding?: boolean;
}

export default function PagingView({
  content,
  isInitialLoad,
  isLoadingMore,
  error,
  page,
  pageSize,
  currentPageSize,
  hasPreviousPage,
  hasNextPage,
  omitPager,
  disablePadding,
  onUpdatePage,
  onUpdatePageSize,
}: Props): React.ReactElement {
  return (
    <div>
      {isInitialLoad ? <PageLoading /> : content}
      {omitPager ? null : (
        <RightPager
          page={page}
          pageSize={pageSize}
          currentPageSize={currentPageSize}
          hasPreviousPage={hasPreviousPage}
          hasNextPage={hasNextPage}
          onUpdatePage={onUpdatePage}
          onUpdatePageSize={onUpdatePageSize}
          isLoading={isLoadingMore}
          error={error}
          disablePadding={disablePadding}
        />
      )}
    </div>
  );
}
